<template lang="pug">
v-app-bar.pa-0.ma-0(app :color="headerColor" dark elevation="1" :class="{'not-fixed-header': isNotFixedHeader, 'desktop-headers': !isMobile}")
  v-row.ma-0.pa-0(v-if="!isMobile" align="center" justify="space-between")
    v-col.ma-0.pa-0(cols="3")
      logo(@open-menu="$emit('open-menu')")

    v-col.pa-0.ma-0(cols="4")
      v-row.pa-0(justify="center")
        v-btn(
          rounded
          v-if="back"
          icon
          color="primary"
          @click="goBack"
        )
          v-icon(large) mdi-keyboard-backspace
        v-toolbar-title.header-text.primary--text {{ $route.query.gr_name ? $route.query.gr_name + $t('common.no_ja') + title : title }}
    v-col.ma-0.pa-0.pr-2(cols="5")
      v-row.ma-0(justify="end")
        //- job-date
        .d-flex.flex-column.justify-center.align-center
          locale-dropdown.local-dropdown
          .version {{`ver ${currentVersion}`}}
        //- j-notifications
        profile-menu
        //portal-target(name="header-action")

  v-row.ma-0.pa-0(v-else align="center" justify="space-between")
    v-row.ma-0.pa-0(align="center").mobile-flex
      v-col.pa-0(cols="1")
        v-btn.pr-3.btn-icon(icon @click="$emit('open-menu')" :style="{'width': '38px'}")
          v-icon(x-large color="primary" :style="{'font-size': '30px'}") mdi-menu
      v-col.ma-0.pa-0.pl-4(:cols="$route.path && $vuetify.breakpoint.xsOnly !== '/' ? 1 : 2")
        logo(
          @is-demo="handleIsDemo"
          :is-mobile="isMobile"
        )
      v-col.justify-center.text-center.pa-0.mobile-text
        v-row.justify-center.align-center.flex-nowrap
          v-btn(
          rounded
          v-if="back"
          icon
          color="primary"
          @click="goBack")
            v-icon(large) mdi-keyboard-backspace
          v-toolbar-title.header-mobile-text.primary--text(v-if="!isAssignmentHeader" style="text-align: center")
            span(:style="'font-size: 0.9em;'") {{ $route.query.gr_name ? $route.query.gr_name + $t('common.no_ja') + title : title }}
          span.test-text(v-if="isHomepage && isDemoValue" :style="'background-color:' + colorDescription") {{ webDescription }}
          .header-mobile-text.primary--text(v-if="isAssignmentHeader")
            portal-target(name="header-title")
          .sub-header-mobile-text.primary--text(v-if="isAssignmentHeader" )
            portal-target(name="header-sub-title")

    v-col.mobile-icon-cart.ma-0.pa-0(:cols="$route.path !== '/' && $vuetify.breakpoint.xsOnly ? 1 : 4")
      v-row.ma-0.mobile-icon(justify="end" align="center" :style="{'font-size': isResize ? '14px': '16px'}" :class="$route.path === '/' ? 'flex-nowrap' : ''" )
        //- job-date(v-if="$route.path === '/'" :is-mobile="isMobile")
        //- j-notifications(v-if="$route.path === '/'" :is-mobile="isMobile")
        portal-target(name="header-action")

</template>

<script>
import {
  computed,
  defineComponent,
  getCurrentInstance,
  ref,
  watch,
  onMounted
} from 'vue'
import Logo from './Logo'
import ProfileMenu from './ProfileMenu'
import LocaleDropdown from './LocaleDropdown.vue'
import { backPage } from '@/utils'
import { system_version } from '@/../package.json'

// import { useI18n } from 'vue-i18n'

const JHeaderMenu = defineComponent({
  components: { Logo, ProfileMenu, LocaleDropdown },
  props: {
    back: {
      type: Boolean,
      required: false,
      default: false
    },
    isMobile: {
      type: Boolean,
      required: false,
      default: false
    },
    isResize: {
      type: Boolean,
      required: false,
      default: false
    },
    isNotFixedHeader: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    const instance = getCurrentInstance()
    const { $root } = instance.proxy

    // const { t } = useI18n()
    const colorDescription = process.env.VUE_APP_WEB_DESCRIPTION
      ? process.env.VUE_APP_DESCRIPTION_COLOR
        ? process.env.VUE_APP_DESCRIPTION_COLOR
        : 'green'
      : ''
    const webDescription = process.env.VUE_APP_WEB_DESCRIPTION

    const goBack = () => {
      backPage()
    }

    const isAssignmentHeader = ref(false)
    const isHomepage = ref(false)

    const isDemoValue = ref(false)

    const handleIsDemo = (value) => {
      isDemoValue.value = value
    }

    const headerColor = computed(() => {
      const environment = process.env.VUE_APP_ENVIRONMENT
      if (environment.toLocaleLowerCase() === 'dev') return '#FFFDD0'
      if (environment.toLocaleLowerCase() === 'demo') return '#E0FFFF'
      return 'white'
    })
    const currentVersion = ref(system_version)
    const title = computed(() => {
      return $root.$t('menu.' + $root.$route.name)
    })
    watch(
      () => $root.$route.fullPath,
      () => {
        const { path } = $root.$route
        if (path === '/assignment/mobile/form/create') {
          isAssignmentHeader.value = true
        } else {
          isAssignmentHeader.value = false
        }
        if (path === '/') {
          isHomepage.value = true
        } else {
          isHomepage.value = false
        }
      },
      { immediate: true }
    )
    const resizeText = () => {
      const mobileTitle = document.querySelector('.mobile-text')
      const mobileFlex = document.querySelector('.mobile-flex')
      const mobileIconCart = document.querySelector('.mobile-icon-cart')
      const mobileFlexWidth = mobileFlex.offsetWidth
      const children = mobileFlex.querySelectorAll(':scope > *')
      let totalWidth = 0
      children.forEach((child) => {
        if (child !== mobileTitle) {
          totalWidth += child.offsetWidth
        }
      })

      const availableWidth =
        mobileFlexWidth - totalWidth - mobileIconCart.offsetWidth
      mobileTitle.style.width = availableWidth + 'px'
    }
    onMounted(() => {
      if (props.isMobile) {
        resizeText()
      }
    })
    return {
      goBack,
      colorDescription,
      webDescription,
      isAssignmentHeader,
      isHomepage,
      handleIsDemo,
      isDemoValue,
      headerColor,
      title,
      currentVersion
    }
  }
})
export default JHeaderMenu
</script>

<style lang="sass" scoped>
@import '@/style/css/common.sass'
.header-text
  font-size: 30px
  font-weight: bold
.header-mobile-text
  font-size: 20px
  font-weight: bold
.sub-header-mobile-text
  font-size: 16px
  font-weight: bold
::v-deep .v-toolbar__content
    padding-right: 0 !important
.test-text
    letter-spacing: 10px
    padding-top: 3px
    padding-left: 7px
    padding-right: 7px
    font-size: 28px
    font-weight: bold
    color: white
    border-radius: 4px
    @media (max-width: 820px)
      font-size: 18px
      letter-spacing: 4px
      padding-top: 3px
    @media (max-width: 600px)
      font-size: 10px
      padding-top: 3px
@media (max-width: 400px)
  .mobile-text
    padding-right: 0 !important
    margin-left: -5px !important
  .mobile-icon
    padding-right: 5px !important
  .mobile-btn
    height: 40px !important
  .mobile-flex
    flex: 1 1 0
@media (max-width: 600px)
  .header-mobile-text
    height: 24px
    text-align: center
    display: flex
    justify-content: center
    align-items: center
    overflow: hidden
    span
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
.not-fixed-header
  position: absolute !important
.desktop-headers
  z-index: 8
.version
  color: rgba(0, 0, 0, .81)
.local-dropdown
  margin-bottom: -10px
</style>
